import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    menuItem: {
        color: theme?.checkDetails.menuItemColor,
    },
    price: {
        color: theme?.checkDetails.menuItemPriceColor,
        position: 'absolute',
        right: 0,
        width: '5vw',
    },
    modifierName: {
        color: theme?.checkDetails.modifierColor,
    },
    modifierPrice: {
        color: theme?.checkDetails.modifierPriceColor,
        width: '5vw',
        position: 'absolute',
        right: 0,
    },
    checkItem: {
        borderBottomWidth: '0.1px',
        borderBottomColor: theme?.checkDetails.checkItemBorderColor,
        borderBottomStyle: 'solid',
    },
    pendingBg: {
        backgroundColor: theme?.checkDetails.pendingColor,
    },
    comment: {
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '12px',
        color: theme?.checkDetails.commentColor,
        paddingLeft: '12px',
        marginBottom: '8px',
    },
    modComment: {
        fontSize: '10px',
        fontWeight: '400',
        lineHeight: '12px',
        color: theme?.checkDetails.modifierCommentColor,
        marginBottom: '5px',
    },
    discountHeader: {
        color: theme?.checkDetails.discountColor,
    }
}));

export default useStyles;